// @flow
import type { ExpressParams, FetchFrontendConfigurationResponse } from '@rover/react-lib/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import { camelize } from '@rover/utilities/object-utilities';
import { getAxiosInstance } from '@rover/utilities/axiosUtils';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const CONFIGURATION_URL: string = fullApiUrl('frontend/configuration/');

// Note - this is a form action url, not an api url.  To be cleaned up in DEV-42041
export const SET_LANGUAGE_URL = '/set-language/';

export const get = async (
  expressParams: ?ExpressParams
): Promise<FetchFrontendConfigurationResponse> => {
  const ai = getAxiosInstance(expressParams);

  try {
    const { data } = await ai.get(CONFIGURATION_URL);
    const camelData = camelize(data, true);
    return camelData;
  } catch (e) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while fetching the frontend configuration.'
    );
  }
};

export const setLanguage = async ({ language }: { language: string }): Promise<void> => {
  const ai = getAxiosInstance();

  const formData = new FormData();
  formData.append('language', language);

  try {
    await ai({
      method: 'post',
      url: SET_LANGUAGE_URL,
      data: formData,
      config: {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      },
    });

    return Promise.resolve();
  } catch (error) {
    throw DefaultAPIErrorHandler(error, 'There was an error setting your current language');
  }
};

export default { get, setLanguage };



// WEBPACK FOOTER //
// ../react-lib/src/apis/frontendConfiguration.api.js